export default {"src":"/_next/static/media/virus_24.7d6a0c51.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};